<template>
  <div class="container py-3">
    <div
      class="image-grid"
      :style="gridStyle"
    >
      <div
        class="image-card position-relative zoom-img-container cursor-pointer"
        v-for="(item, index) in images_data"
        :key="index"
        :style="cardStyle"
        @click="goToGroup(item.link)"
      >
        <img :src="item.image_url" class="img-fluid zoom-img" :alt="'image-' + index" />
        <div class="text-content text-center" v-html="item.text_content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImagesCards',
  props: {
    images_data: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      default: () => ({
        gridCols: 3,
        gridRows: 'auto',
        gap: '1rem',
        imageWidth: '100%',
        imageHeight: 'auto'
      })
    }
  },
  computed: {
    gridStyle() {
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${this.config.gridCols}, 1fr)`,
        gridTemplateRows: this.config.gridRows === 'auto' ? undefined : `repeat(${this.config.gridRows}, 1fr)`,
        gap: this.config.gap
      };
    },
    cardStyle() {
      return {
        width: this.config.imageWidth,
        height: this.config.imageHeight,
        overflow: 'hidden'
      };
    }
  },
  methods: {
    goToGroup(url) {
      window.open(url, '_blank');
    }
  },
};
</script>

<style scoped>
.image-card img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.text-content {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  color: white;
}
</style>
